import { Slide } from "@jelly/lesson";
import theory from "../../theory";

import case1 from "./components/case-1";
import case2 from "./components/case-2";
import case3 from "./components/case-3";
import case4 from "./components/case-4";

const principle: Slide = {
  description:
    "A technical room is located next to a classroom. The sound pressure level (SPL) in the technical space is high (SPL > 70 dB) and the background noise level in the classroom needs to be low enough for students to concentrate and listen to the course. See below different access scenarii and their consequences on sound insulation between the technical room and the classroom. Note that doors are drawn open for clarity but are considered to be closed for the acoustic assessment.\n",
  theory: theory,
  layout: {
    type: "controlsToggleExtraContent",
    options: {
      controls: [
        {
          type: "dropdown",
          options: {},
          items: [
            { name: "Scenario 1: single door - no acoustic rating" },
            { name: "Scenario 2: single door - with acoustic rating" },
            { name: "Scenario 3: sound & light lock (SLL)" },
            { name: "Scenario 4: other design" },
          ],
        },
      ],
      controlsPosition: "bottom",
      extraContent: [[], [], [], []],
      components: [case1, case2, case3, case4],
    },
  },
};

export default principle;
